angular.
module("dx.webapp.archive", [
	"dx.webapp.api",
]);
